import { Input, Select } from 'antd';
import moment from 'moment-jalaali';
import React from 'react';
import StringHelper from '../helpers/StringHelper';

const faNum = StringHelper.getFarsiNum;

class BirthdateInput extends React.Component {
  constructor(props) {
    super(props);

    const value = props.value || {};
    this.state = {
      day: value.day,
      month: value.month,
      year: value.year,
    };
  }

  static getDerivedStateFromProps(nextProps) {
    if ('value' in nextProps) {
      return {
        ...(nextProps.value || {}),
      };
    }
    return null;
  }

  onDayChange = day => {
    if (!('value' in this.props)) {
      this.setState({ day })
    }
    this.triggerChange({ day });
  };

  onMonthChange = month => {
    if (!('value' in this.props)) {
      this.setState({ month })
    }
    this.triggerChange({ month });
  };

  onYearChange = year => {
    if (!('value' in this.props)) {
      this.setState({ year })
    }

    this.triggerChange({ year });
  };

  triggerChange = changedValue => {
    const { onChange } = this.props;
    if (onChange) {
      onChange({
        ...this.state,
        ...changedValue,
      });
    }
  };

  render() {
    const years = []
    const days = []
    const months = [
      {
        name: "فروردین",
        value: 1
      },
      {
        name: "اردیبهشت",
        value: 2
      },
      {
        name: "خرداد",
        value: 3
      },
      {
        name: "تیر",
        value: 4
      },
      {
        name: "مرداد",
        value: 5
      },
      {
        name: "شهریور",
        value: 6
      },
      {
        name: "مهر",
        value: 7
      },
      {
        name: "آبان",
        value: 8
      },
      {
        name: "آذر",
        value: 9
      },
      {
        name: "دی",
        value: 10
      },
      {
        name: "بهمن",
        value: 11
      },
      {
        name: "اسفند",
        value: 12
      },
    ]


    const currentYear = moment().jYear()
    for (let i = currentYear; i > currentYear - 100; i--) {
      years.push(i)
    }

    for (let i = 1; i < 32; i++) {
      days.push(i)
    }

    const { forwardedRef, ...rest } = this.props;

    return (
      <div ref={forwardedRef} {...rest} className="birthdate-input">
        <Input.Group compact>
          <Select
            disabled={this.props.disabled}
            placeholder="روز"
            value={this.state.day}
            onChange={this.onDayChange}
            style={{ minWidth: "30%" }}>
            {days.map((day, index) => <Select.Option key={index} value={day}>{faNum(day)}</Select.Option>)}
          </Select>
          <Select
            disabled={this.props.disabled}
            onChange={this.onMonthChange}
            value={this.state.month}
            placeholder="ماه"
            style={{ minWidth: "40%" }}>
            {months.map((month, index) => <Select.Option key={index} value={month.value}>{month.name}</Select.Option>)}
          </Select>
          <Select
            disabled={this.props.disabled}
            value={this.state.year}
            onChange={this.onYearChange}
            placeholder="سال"
            style={{ minWidth: "30%" }}>
            {years.map((year, index) => <Select.Option key={index} value={year}>{faNum(year)}</Select.Option>)}
          </Select>
        </Input.Group>
      </div>
    );
  }
}

export default React.forwardRef((props, ref) =>
  <BirthdateInput {...props} forwardedRef={ref} />
);
